module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings) ? _c('div', {
    staticClass: "project-trackings"
  }, [_c('div', {
    staticClass: "statistics-global"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('statistics.latest_trackings')))]), _vm._v(" "), _c('relative-date-choser', {
    attrs: {
      "choices": [1, 7, 30, 60]
    },
    on: {
      "change": _vm.dateChange
    }
  })], 1)]), _vm._v(" "), (_vm.trackingsSorted.length > 0) ? _c('div', _vm._l((_vm.trackingsSorted), function(trackings) {
    return _c('div', {
      key: trackings[0].time,
      staticClass: "tracking-table"
    }, [_c('div', {
      staticClass: "tracking-table--date"
    }, [_vm._v("\n          " + _vm._s(_vm.moment(trackings[0].time).format('MMMM Do')) + "\n        ")]), _vm._v(" "), _c('tracking-table', {
      attrs: {
        "project-id": _vm.id,
        "trackings": trackings
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('statistics.no_data')) + "\n    ")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-928ad7f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectTrackingsFrame.vue
// module id = 1966
// module chunks = 0